
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.3478 15.9927C21.1764 12.0408 20.8156 6.51143 17.2668 2.96264C13.3168 -0.987327 6.91303 -0.987764 2.96264 2.96264C-0.987764 6.91303 -0.987327 13.3168 2.96264 17.2668C6.51143 20.8156 12.0408 21.1764 15.9927 18.3478C16.0631 18.7395 16.2491 19.11 16.5516 19.4124L20.8428 23.7036C21.2378 24.0986 21.8779 24.0989 22.2732 23.7036L23.7036 22.2732C24.0989 21.8779 24.0986 21.2378 23.7036 20.8428L19.4124 16.5516C19.11 16.2491 18.7395 16.0631 18.3478 15.9927ZM14.4059 5.82346C16.7759 8.19346 16.7765 12.0354 14.4059 14.4059C12.0354 16.7765 8.19346 16.7759 5.82346 14.4059C3.45347 12.0359 3.45294 8.19398 5.82346 5.82346C8.19398 3.45294 12.0359 3.45347 14.4059 5.82346Z","fill":"white"}})])
          )
        }
      }
    